import { Component, Inject, Injector, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RootMixin, UserAwareMixin } from '@asp/mixins';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';

@Component({
  selector: 'app-quick-add-menu',
  templateUrl: './quick-add-menu.component.html',
  styleUrls: ['./quick-add-menu.component.scss'],
})
export class QuickAddMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;

  constructor(
    @Inject(TuiDialogService) private readonly dialogs: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector,
  ) {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser),
    );
  }

  qaUser(): void {
    import('../../../views/shared/users/user-edit/user-edit.component').then(
      ({ UserEditComponent }) => {
        // noinspection TypeScriptValidateTypes
        this.dialogs
          .open<any>(
            new PolymorpheusComponent(UserEditComponent, this.injector),
            {
              dismissible: false,
              closeable: false,
              size: 'auto',
              appearance: 'quick-add',
            },
          )
          .subscribe();
      },
    );
  }

  qaCompany(): void {
    import(
      '../../../views/shared/companies/company-edit/company-edit.component'
    ).then(({ CompanyEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(CompanyEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }

  qaRfidTag(): void {
    import(
      '../../../views/shared/rfid-tags/rfid-tag-edit/rfid-tag-edit.component'
    ).then(({ RfidTagEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(RfidTagEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }

  qaCategory(): void {
    import(
      '../../../views/shared/categories/category-edit/category-edit.component'
    ).then(({ CategoryEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(CategoryEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }

  qaAsset(): void {
    import('../../../views/shared/assets/asset-edit/asset-edit.component').then(
      ({ AssetEditComponent }) => {
        // noinspection TypeScriptValidateTypes
        this.dialogs
          .open<any>(
            new PolymorpheusComponent(AssetEditComponent, this.injector),
            {
              dismissible: false,
              closeable: false,
              size: 'auto',
              appearance: 'quick-add',
            },
          )
          .subscribe();
      },
    );
  }

  qaLocation(): void {
    import(
      '../../../views/shared/locations/location-edit/location-edit.component'
    ).then(({ LocationEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(LocationEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }

  qaPerson(): void {
    import(
      '../../../views/shared/persons/person-edit/person-edit.component'
    ).then(({ PersonEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(PersonEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }

  qaProject(): void {
    import(
      '../../../views/shared/projects/project-edit/project-edit.component'
    ).then(({ ProjectEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(ProjectEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          },
        )
        .subscribe();
    });
  }
}
